import React from 'react';
import { GfBorderWrapper } from '../../gfcomponents/GfBorderWrapper/GfBorderWrapper';
import AutoResizingTextarea from '../../components/AutoResizingTextArea';
import AiMagic from '../../icons/AiMagic';
import { Loader } from 'semantic-ui-react';

interface AgentPopupInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  disabled: boolean;
}

export default function AgentPopupInput({ value, onChange, onKeyDown, onSend, disabled }: AgentPopupInputProps) {
  return (
    <div className="ai-popup-footer">
      <GfBorderWrapper className="input-wrapper">
        <AutoResizingTextarea value={value} onChange={onChange} onKeyDown={onKeyDown} placeholder="Start Typing" disabled={disabled} />
        {!disabled && (
          <button className="ai-send-button" onClick={onSend} disabled={disabled}>
            <AiMagic />
          </button>
        )}
        {disabled && <Loader active inline size="small" style={{ marginRight: '4px' }}></Loader>}
      </GfBorderWrapper>
    </div>
  );
}
